<template>
  <v-container>
    <div v-show="isVisibleProp"></div>
    <v-row>
      <v-col cols="3">
        <v-text-field
          id="sharedBankEditItemBankName"
          class="shared-bank-edit-item-bank-name"
          :autofocus="true"
          label="Bank Name"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.bankName"
          :rules="reqdSelectValidation"
        >
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
          id="sharedBankEditItemAccountNumber"
          class="shared-bank-edit-item-account-number"
          label="Account Number"
          v-model="editedItem.accountNumber"
        >
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
          id="sharedBankEditItemRoutingNumber"
          class="shared-bank-edit-item-routing-number"
          label="Routing Number"
          v-model="editedItem.routingNumber"
        >
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
          id="sharedBankEditItemAltKeyBase"
          class="shared-bank-edit-item-alt-key-base"
          label="Alt Key"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.altKeyBase"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-combobox
          id="sharedBankEditItemGroupCode"
          class="shared-bank-edit-item-group-code"
          label="Group Code"
          v-model="editedItem.groupCode"
          :items="bankGroupCodesUsingInitials"
          item-text="groupCodes"
          item-value="_id"
          @change="getCollateralInfo"
        >
        </v-combobox>
      </v-col>
      <v-col cols="3">
        <v-text-field
          id="sharedBankEditItemBankCode"
          class="shared-bank-edit-item-bank-code"
          label="Bank Acct Code"
          v-model="editedItem.bankCode"
        >
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
          id="sharedBankEditItemLine"
          class="shared-bank-edit-item-line"
          label="Line"
          v-model.number="editedItem.line"
          type="number"
        >
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
          id="sharedBankEditItemLocation"
          class="shared-bank-edit-item-location"
          label="Location"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.location"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2">
        <v-checkbox
          id="sharedBankEditItemIsInvAcct"
          class="shared-bank-edit-item-is-inv-acct"
          label="Inv Acct"
          @change="handleCheckboxChange('isInvAcct')"
          v-model="editedItem.isInvAcct"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="2">
        <v-checkbox
          id="sharedBankEditItemIsReconAcct"
          class="shared-bank-edit-item-is-recon-acct"
          label="Recon Acct"
          v-model="editedItem.isReconAcct"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="2">
        <v-checkbox
          id="sharedBankEditItemIsSubledger"
          class="shared-bank-edit-item-is-subledger"
          label="Subledger"
          v-model="editedItem.isSubledger"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="2">
        <v-checkbox
          id="sharedBankEditItemIsAlwaysPrint"
          class="shared-bank-edit-item-is-always-print"
          label="Always Print"
          v-model="editedItem.isAlwaysPrint"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="2">
        <v-checkbox
          id="sharedBankEditItemIsOD"
          class="shared-bank-edit-item-is-od"
          label="OD Bank"
          v-model="editedItem.isOD"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="2">
        <v-checkbox
          id="sharedBankEditItemIsCash"
          class="shared-bank-edit-item-is-cash"
          label="Cash Bank"
          v-model="editedItem.isCash"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="2">
        <v-checkbox
          id="sharedBankEditItemIsSweepAcct"
          class="shared-bank-edit-item-is-sweep-acct"
          label="Sweep Acct"
          @change="handleCheckboxChange('isSweepAcct')"
          v-model="editedItem.isSweepAcct"
        >
        </v-checkbox>
      </v-col>
       <v-col cols="3">
        <v-checkbox
          id="sharedBankEditItemIsDepositSlipEnabled"
          class="shared-bank-edit-item-is-deposit-slip"
          label="Deposit Slip Enabled"
          v-model="editedItem.isDepositSlipEnabled"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-tooltip bottom max-width="350">
          <template v-slot:activator="{ on, attrs }">
            <v-checkbox
              id="sharedBankEditItemHideFromSharedList"
              class="shared-bank-edit-item-hide-from-shared-list"
              label="Hide from Shared List"
              v-model="editedItem.hideFromSharedList"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
            </v-checkbox>
          </template>
          <span>
            Hides this bank from the Shared Bank list view for easier navigation.
            The bank will still appear on all reports.
          </span>
        </v-tooltip>
      </v-col>
      <v-col cols="3">
        <v-tooltip bottom max-width="400">
          <template v-slot:activator="{ on, attrs }">
            <v-checkbox
              id="sharedBankEditItemHideOnReports"
              class="shared-bank-edit-item-hide-on-reports"
              label="Hide on reports"
              v-model="editedItem.hideOnReports"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
            </v-checkbox>
          </template>
          <span>
            Hides this bank from GL, SAI Monthly, SAI Yearly,
            and Bank Collateral reports.
            If the bank has a balance or activity in the current
            fiscal year, it will still appear on reports to keep
            the GL balanced.
          </span>
        </v-tooltip>
      </v-col>
      <v-col cols="3" v-if="editedItem.isSweepAcct">
        <v-text-field
          id="sharedBankEditItemBaseAmount"
          class="shared-bank-edit-item-base-amount"
          label="Base Amount"
          v-model.number="editedItem.isBaseAmount"
          type="number"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="isBankCollateral">
      <v-col>
        <sharedBankCollateralDetails
          :isReadOnly="true"
          :baseCrudKey="baseCrudKey"
          v-model="editedItem.bankCollateralRecord"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import { amountFormat, checkStringEmptiness } from '../../../util/shared/vue-global';
import sharedBankCollateralDetails from './sharedBankCollateralDetails.vue';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'BankEditedItem',
  mixins: [GlobalToCaps],
  components: {
    sharedBankCollateralDetails,
  },
  data: () => ({
    collateralBankCrudKey: 'collateralBank',
    isBankCollateral: false,
    isInvAcct: false,
    isSweepAcct: false,
    isBaseAmount: null,
  }),
  props: {
    baseCrudKey: {
      type: String,
      default: 'bank-dialog',
    },
  },
  created() {
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'item',
      'items',
      'isVisible',
    ]),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    changes() {
      return this.editedItem.changes || [];
    },
    reqdSelectValidation() {
      return [
        (value) => !!value || 'Required',
      ];
    },
    isVisibleProp() {
      const isVisible = this.isVisible(this.baseCrudKey);
      if (isVisible) {
        this.getCollateralInfo();
      }
      return isVisible;
    },
    bankGroupCodesUsingInitials() {
      const collateralBankObjs = this.items(this.collateralBankCrudKey) || [];
      const updatedObj = collateralBankObjs.map((c) => c.bankIntials).filter(Boolean);
      return updatedObj;
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    getCollateralInfo() {
      const collateralList = this.items(this.collateralBankCrudKey);
      this.editedItem.bankCollateralRecord = {};
      this.isBankCollateral = false;
      if (!checkStringEmptiness(this.editedItem.groupCode)) {
        for (let i = 0; i < collateralList.length; i += 1) {
          if (this.editedItem.groupCode === collateralList[i].bankIntials) {
            for (let j = 0; j < (collateralList[i].details || []).length; j += 1) {
              collateralList[i].details[j].fdic = amountFormat(collateralList[i].details[j].fdic);
              collateralList[i].details[j].loc = amountFormat(collateralList[i].details[j].loc);
              collateralList[i].details[j].pledges = amountFormat(
                collateralList[i].details[j].pledges,
              );
              collateralList[i].details[j].sweep = amountFormat(collateralList[i].details[j].sweep);
            }
            this.editedItem.bankCollateralRecord = collateralList[i];
            this.isBankCollateral = true;
          }
        }
      }
    },
    handleCheckboxChange(checkbox) {
      if (checkbox === 'isInvAcct' && this.editedItem.isInvAcct) {
        this.editedItem.isSweepAcct = false;
      } else if (checkbox === 'isSweepAcct' && this.editedItem.isSweepAcct) {
        this.editedItem.isInvAcct = false;
      }
    },
  },
};
</script>
